// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "a[data-v-52734718],span[data-v-52734718]{font-size:.625rem;line-height:.9375rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
